import { useEffect, useRef, useState } from "react";
import { Drawer, Avatar, message } from "antd"
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import EmailIcon from '../../../assets/email.svg';
import UserImage from '../../../assets/user.svg';
import TelIcon from '../../../assets/dashboard/tell-1.svg';
import EditProfileIcon from '../../../assets/dashboard/edit-profile.svg';
import { profileValidation } from "../../../utils/validations/formValidations";
import { getFromLocalStorage, setInLocalStorage } from '../../../utils/storageUtil';
import { UpdateProfile } from "../../../utils/api";
import ImageUploader from "../ImageUploader";

const EditProfile = ({ openEditProfile, setOpenEditProfile }) => {

    const [isLoading, setIsLoading] = useState(false);
    const [avatarUrl, setAvatarUrl] = useState('');

    // Uploader States
    const [openUpload, setOpenUpload] = useState(false);
    const [file, setFile] = useState(null);
    const [cropper, setCropper] = useState(null);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [loadingCrop, setLoadingCrop] = useState(false);
    const [uploadComplete, setUploadComplete] = useState(false);
    const fileInputRef = useRef(null);




    const { register, handleSubmit, setValue, formState: { errors, isDirty, isValid } } = useForm({
        resolver: yupResolver(profileValidation),
    },);

    const onSubmit = async (data) => {
        if (!isDirty && !isValid) {
            return;
        }
        try {
            setIsLoading(true);
            const formData = {
                name: data.name,
                email: data.email,
                phone_number: data.phone,
                image: avatarUrl,
            };
            const response = await UpdateProfile(formData, getFromLocalStorage('admin')?.id)
            if (response?.isSuccess) {
                message.success('Profile updated Successfully');
                setInLocalStorage('admin', response?.data);
                setIsLoading(false);
                setOpenEditProfile(false);
            } else {
                message.error(response?.error);
                setIsLoading(false);
            }
        } catch (error) {
            setIsLoading(false);
        }
    }

    const handleClose = () => {
        setOpenEditProfile(false);
    }

    const closeUploadModal = () => {
        setFile(null);
        setCropper(null)
        setOpenUpload(false);
    }

    useEffect(() => {
        if (uploadComplete) {
            const timeout = setTimeout(() => {
                setUploadComplete(false);
                setCropper(null);
            }, 2000);
            return () => clearTimeout(timeout);
        }
    }, [uploadComplete]);


    useEffect(() => {
        setValue('name', getFromLocalStorage('admin').name);
        setValue('email', getFromLocalStorage('admin').email);
        setValue('phone', getFromLocalStorage('admin').phone_number);
        setAvatarUrl(getFromLocalStorage('admin').image);
    }, [openEditProfile]);

    return (
        <>
            <Drawer title="Edit Profile" placement="right" onClose={handleClose} open={openEditProfile}>

                <div className='w-full poppins mt-8'>
                    <div className="relative w-max mx-auto">
                        <Avatar
                            style={{ width: '100px', height: '100px', border: '1.5px solid #61373f', padding: '3px' }}
                            src={
                                <img className="rounded-full w-[100px] h-[100px] object-cover" src={avatarUrl} alt="avatar" />
                            } />
                        <span className='absolute right-2 bottom-0 cursor-pointer' onClick={() => setOpenUpload(true)}><img src={EditProfileIcon} alt="edit-profile" /></span>
                        <ImageUploader
                            openUpload={openUpload}
                            file={file}
                            setFile={setFile}
                            cropper={cropper}
                            setCropper={setCropper}
                            uploadProgress={uploadProgress}
                            setUploadProgress={setUploadProgress}
                            loadingCrop={loadingCrop}
                            setLoadingCrop={setLoadingCrop}
                            message={message}
                            setUploadComplete={setUploadComplete}
                            closeUploadModal={closeUploadModal}
                            fileInputRef={fileInputRef}
                            changeImageState={setAvatarUrl}
                        />
                    </div>


                    <form className="flex flex-col" onSubmit={handleSubmit(onSubmit)} noValidate>
                        <div className="border border-input-placeholder flex gap-x-2 rounded-lg p-3 relative mt-4">
                            <label className="absolute bg-white text-input-label -top-2 left-5 text-[11px] px-1" htmlFor="name">Name</label>
                            <img src={UserImage} className="invert-[0.5]" alt="name-svg" width={12} />
                            <input className="w-full outline-none text-[12px] text-input-placeholder" type="text" id="name" {...register('name')} />
                        </div>
                        <p className="text-[red] text-[12px]">{errors.name?.message}</p>
                        <div className="border border-input-placeholder flex gap-x-2 rounded-lg p-3 relative mt-4">
                            <label className="absolute bg-white text-input-label -top-2 left-5 text-[11px] px-1" htmlFor="email">Email</label>
                            <img src={EmailIcon} alt="mail-svg" width={12} />
                            <input className="w-full outline-none text-[12px] text-input-placeholder" type="email" id="email" {...register('email')} />
                        </div>
                        <p className="text-[red] text-[12px]">{errors.email?.message}</p>
                        <div className="border border-input-placeholder flex gap-x-2 rounded-lg p-3 relative mt-4">
                            <label className="absolute bg-white text-input-label -top-2 left-5 text-[11px] px-1" htmlFor="phone">Phone</label>
                            <img src={TelIcon} alt="password-svg" width={12} />
                            <input className="w-full outline-none text-[12px] text-input-placeholder" type='number' id="phone" {...register('phone')} />
                        </div>
                        <p className="text-[red] text-[12px]">{errors.phone?.message}</p>

                        <div className="mt-6 flex items-center justify-center gap-x-3">
                            <button type="button" className=" bg-white text-primary-700 border border-primary-700 text-[10px] px-12 py-3 rounded-lg" onClick={handleClose}>Back</button>
                            <button
                                type="submit"
                                className="bg-primary-700 border border-primary-700 text-white text-[10px] px-12 py-3 rounded-lg flex items-center gap-x-2"
                                disabled={isLoading}
                            >
                                Submit
                                {isLoading && <span className="loader"></span>}
                            </button>
                        </div>
                    </form>
                </div>
            </Drawer>
        </>
    )
}

export default EditProfile;